export default {
  // Asset information
  totalAsset: "Total Assets (Available Balance)",
  updated: "Updated",

  // Tooltip
  assetBalanceTooltip:
    "The address total asset balance is calculated by converting all main coins and tokens held by the address to USDT based on the currency values collected by this system",
  systemSupport: "The system currently supports",
  supportedCurrencies: "317 currencies",
  tronSupport: "Tron chain currency data currently only supports TRX and USDT",

  // Blacklist labels
  usdtBlocked: "# USDT BLOCKED",
  usdcBlocked: "# USDC BLOCKED",

  // Tron data calculation
  tronCalculating: "Tron data is being calculated, please check back later",

  // Dialog title
  assetBalanceChange: "Total Asset Balance Change",
};
